/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_CreateInputs */

const en_us2_clubs_create = /** @type {(inputs: Clubs_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a club`)
};

const pt_br2_clubs_create = /** @type {(inputs: Clubs_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar clube`)
};

const es_419_clubs_create = /** @type {(inputs: Clubs_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear un club`)
};

const pt_pt2_clubs_create = /** @type {(inputs: Clubs_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar clube`)
};

const fr_fr2_clubs_create = /** @type {(inputs: Clubs_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un club`)
};

const de_de2_clubs_create = /** @type {(inputs: Clubs_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club erstellen`)
};

const it_it2_clubs_create = /** @type {(inputs: Clubs_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un club`)
};

/**
* | output |
* | --- |
* | "Create a club" |
*
* @param {Clubs_CreateInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_create = /** @type {((inputs?: Clubs_CreateInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_CreateInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_create(inputs)
	if (locale === "es-419") return es_419_clubs_create(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_create(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_create(inputs)
	if (locale === "de-DE") return de_de2_clubs_create(inputs)
	if (locale === "it-IT") return it_it2_clubs_create(inputs)
	return en_us2_clubs_create(inputs)
});
export { clubs_create as "clubs.create" }